
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDuctStraight as ObiDuctStraightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-duct-straight.js';
 
 
 

 
 export const ObiDuctStraight = createComponent({
   react: React,
   tagName: 'obi-duct-straight',
   elementClass: ObiDuctStraightElement,
   events: {
     
   }
  });
 
 